import { CHILEAN_REGIONS } from "~/constants/places";

const REGION_PATTERNS: Record<string, RegExp> = {
  metropolitana: /metropolitana|xiii region/i,
  valparaiso: /valparaiso|valparaíso|quinta.*regi[oó]n/i,
  ohiggins: /higgins|sexta.*regi[oó]n/i,
  biobio: /biobio|bío.*bío|bio-bio|octava.*regi[oó]n|región del biobío/i,
  maule: /s[eé]ptima.*regi[oó]n/i,
  coquimbo: /cuarta.*regi[oó]n|región de coquimbo/i,
  araucania: /araucan[ií]a|novena.*regi[oó]n/i,
  antofagasta: /segunda.*regi[oó]n|región de antofagasta/i,
  los_lagos: /d[eé]cima.*regi[oó]n.*lagos/i,
  los_rios: /los r[ií]os|d[eé]cimo cuarta/i,
  nuble: /d[eé]cimo sexta/i,
  atacama: /tercera.*regi[oó]n|región de atacama/i,
  tarapaca: /primera.*regi[oó]n|región de tarapacá/i,
  magallanes: /duod[eé]cima.*regi[oó]n/i,
  aysen: /und[eé]cima.*regi[oó]n|ais[eé]n/i,
  arica_parinacota: /d[eé]cimo quinta|arica.*parinacota/i,
};

/**
 * Normalizes a region string to its canonical Chilean region name.
 * Returns the original value if no match is found (e.g., foreign addresses).
 */
export function normalizeRegion(
  input: string | null | undefined
): string | null {
  if (!input) return null;

  const trimmed = input.trim();

  // Check if already canonical
  const canonical = CHILEAN_REGIONS.find((r) => r.label === trimmed);
  if (canonical) return trimmed;

  // Try to match patterns
  for (const [regionId, pattern] of Object.entries(REGION_PATTERNS)) {
    if (pattern.test(trimmed)) {
      const region = CHILEAN_REGIONS.find((r) => r.value === regionId);
      return region?.label ?? null;
    }
  }

  // Try exact match (case-insensitive)
  const exactMatch = CHILEAN_REGIONS.find(
    (r) => r.label.toLowerCase() === trimmed.toLowerCase()
  );
  if (exactMatch) return exactMatch.label;

  // No match - return original (could be foreign address)
  return trimmed;
}
